import React from "react";
import { FaTimes, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

export default function AlertCard({ type = "info", message, onClose }) {
  const icon = type === "success" ? (
    <FaCheckCircle size={40} color="green" />
  ) : type === "error" ? (
    <FaExclamationCircle size={40} color="red" />
  ) : null;

  return (
    <div className="modal-overlay" style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.3)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
        maxWidth: "400px",
        width: "90%",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        textAlign: "center",
        position: "relative"
      }}>
        <button onClick={onClose} style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          border: "none",
          background: "none",
          fontSize: "20px",
          cursor: "pointer",
          color: "#666"
        }}>
          <FaTimes />
        </button>
        <div style={{ marginBottom: "15px" }}>
          {icon}
        </div>
        <div style={{ fontSize: "16px", color: "#333" }}>
          {message}
        </div>
      </div>
    </div>
  );
}
